import React from "react";
import { Divider as XDivider } from "@mui/material";

const Divider = ({ ...props }) => {
  return <XDivider sx={{ height: '1px', ...props.sx }} {...props} />;
};

export default Divider;
